import { useMemo } from 'react';

import {
  copyScenario,
  detourApiSlice,
  editScenario,
  resetAll,
  setVisualize,
} from 'state/detourSlices';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  selectProject,
  setCurrentScenarioId,
  setRouteSelection,
  setScenarioSetupUIMode,
  setSelectedSegmentId,
} from 'state/workflowSlice';

import { ScenarioSetupUIMode } from 'appConstants';
import { Scenario } from 'appTypes';
import dayjs from 'dayjs';

export function useScenarioUI() {
  const dispatch = useAppDispatch();
  const project_slug = useAppSelector(selectProject);

  // only update cache if it exists
  const updateViewDate = (scenarioId: string) => {
    if (!project_slug) return;
    try {
      dispatch(
        detourApiSlice.util.updateQueryData(
          'getScenarios',
          project_slug,
          (draft) => {
            // draft: { scenarios: Scenario[] }
            const item = draft.scenarios.find(
              (el: any) => el.scenario_id === scenarioId,
            );
            if (item) item.view_date = dayjs().toISOString();
          },
        ),
      );
    } catch (e) {
      console.error('Error while updating cached view_date', e);
    }
  };

  return useMemo(
    () => ({
      setCreateMode() {
        dispatch(setCurrentScenarioId(undefined));
        dispatch(setSelectedSegmentId(undefined));
        dispatch(setRouteSelection(undefined));
        dispatch(resetAll());
        dispatch(setScenarioSetupUIMode(ScenarioSetupUIMode.Create));
      },
      setScenariosMode(scenario?: Scenario) {
        dispatch(setVisualize(true));
        dispatch(setScenarioSetupUIMode(ScenarioSetupUIMode.Scenarios));
        if (scenario) {
          dispatch(setCurrentScenarioId(scenario.scenario_id));
          updateViewDate(scenario.scenario_id);
        }
        dispatch(setSelectedSegmentId(undefined));
        dispatch(setRouteSelection(undefined));
      },
      setInitialMode(closeTaskbar: boolean = true) {
        dispatch(setScenarioSetupUIMode(ScenarioSetupUIMode.Scenarios));
        if (closeTaskbar) dispatch(setCurrentScenarioId(undefined));
      },
      setEditMode(scenario: Scenario) {
        dispatch(setSelectedSegmentId(scenario.segments[0]));
        dispatch(setRouteSelection(scenario.segments));
        dispatch(setCurrentScenarioId(scenario.scenario_id));
        dispatch(editScenario(scenario));
        dispatch(setScenarioSetupUIMode(ScenarioSetupUIMode.Edit));
      },
      setCopyMode(scenario: Scenario) {
        dispatch(setSelectedSegmentId(scenario.segments[0]));
        dispatch(setRouteSelection(scenario.segments));
        dispatch(copyScenario(scenario));
        dispatch(setCurrentScenarioId(undefined));
        dispatch(setScenarioSetupUIMode(ScenarioSetupUIMode.Create));
      },
    }),
    [dispatch, project_slug],
  );
}
